export const SecretLabels: Record<
    "project" | "user",
    {
        newSecretModalDescription: string;
        newSecretModalCreatedToast: string;
        emptyStateDescription: string;
    }
> = {
    project: {
        newSecretModalDescription: "Add a new secret to this project",
        newSecretModalCreatedToast: "The secret is available to all new environments created from this project.",
        emptyStateDescription: "This project has no secrets.",
    },
    user: {
        newSecretModalDescription:
            "Secrets added here will be available in all your environments and will override any existing environment secrets",
        newSecretModalCreatedToast: "The secret is available to all your environments.",
        emptyStateDescription: "You don't have any secrets.",
    },
};
